import React, {useState, useEffect} from 'react'
import '../Styles/LoginPage.css'
import Color from '../../Components/Colors/Color'
import CustomSnackbar from "../Components/Snackbar/Snackbar"
import { handleLoginController } from '../Controller/LoginController';
import { useNavigate } from 'react-router-dom';
import '../Components/Overlay/Overlay.css'
import ClipLoader from "react-spinners/ClipLoader"

const LoginPage = () => {

    const navigate = useNavigate();

    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [loading, setLoading] = useState(false);
    const [user, setUser] = useState({});
    // const [isSignIn, setIsSignIn] = useState(true);
    const [showPassword, setShowPassword] = useState(false);
    const [openSnackbar, setOpenSnackbar] = useState(false);
    const [severitySnackbar, setSeveritySnackbar] = useState("");
    const [messageSnackbar, setMessageSnackbar] = useState("");
    const [success, setSuccess] = useState(false);
    const [snackbarDuration, setSnackbarDuration] = useState(0);
    const [showOverlay, setShowOverlay] = useState(false);

    useEffect(() => {
        sessionStorage.removeItem('otp');
        localStorage.removeItem('email');
        localStorage.removeItem('authToken');
    }, [])

    useEffect(() => {
        const token = localStorage.getItem('authToken');
        if(!openSnackbar && token){
            navigate('/admin-dashboard');
        }

    }, [success && openSnackbar]) 

    

    const handleLogin = async (e) => {
        e.preventDefault();

        if(!email){
            document.getElementById('email-sign-in').focus();
            
            setSeveritySnackbar("error");
            setMessageSnackbar("Enter your email");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
        } 

        if(!password){
            document.getElementById('password-sign-in').focus();

            setSeveritySnackbar("error");
            setMessageSnackbar("Enter your password");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
        } 




        if(!email || !password) return;

        const emailRegex = /^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])$/i;
        var emailTest = emailRegex.test(email);

        if(!emailTest){
            setSeveritySnackbar("error");
            setMessageSnackbar("Invalid Email expression");
            setOpenSnackbar(true);
            setSnackbarDuration(2000);
            return;
        }

        

        const loginInfo = {
            email: email,
            password: password 
        }

        try{
            setLoading(true);
            // Check if authToken exists in session storage before removing
            if (localStorage.getItem('authToken')) {
                localStorage.removeItem('authToken');
            }

            const response = await handleLoginController(loginInfo);
            
            const token = response?.data?.token;

            console.log(response);

            // Check if the token exists before storing it
            if (token) {
                // Store the token in session storage
                localStorage.setItem('authToken', token);

                setSeveritySnackbar("success");
                setMessageSnackbar("Login Successful");
                setOpenSnackbar(true);
                setSnackbarDuration(3000);
                setSuccess(a => !a);
                
            } else {
                setSeveritySnackbar("error");
                setMessageSnackbar(response?.data?.message || "An error has occured");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
            }
            
        }   catch (error) {
                setSeveritySnackbar("error");
                setMessageSnackbar(error?.response?.data?.message || "An error occurred, Please try again");
                setSnackbarDuration(3000);
                setOpenSnackbar(true);
        } finally{
            setLoading(false);
        }
    }

    const handleForgotPasswordPage = (e) => {
        e.preventDefault();
        navigate("./forgot-password");
    }

    const handleKeyPress = (e) => {
        if (e.key === 'Enter') {
            handleLogin(e);
        }
    }

    return(
        <>
            <div className="login-container" style={{backgroundColor: Color.secondaryBackground}}>
                <div className='login-logo-container small-screen'>
                        <img src='/Images/logo.png' alt='opc-logo' className='login-logo' />
                    </div>
                <div className='login-card-container' style={{backgroundColor: Color.primaryBackground}}>
                    <div className='login-logo-container'>
                        <img src='/Images/logo.png' alt='opc-logo' className='login-logo' />
                    </div>
                    <div className='login-header-container'>
                        <h3 className='login-header'>
                            Sign In
                        </h3>
                    </div>

                    <form className='login-form-container' onSubmit={handleLogin}>
                        <div className='login-label-input-container'>
                            <label htmlFor='email' className='login-label'>
                                Email
                            </label>
                            <input
                                type='email'
                                id='email'
                                className='login-input'
                                placeholder='janedoe123@gmail.com'
                                value={email}
                                onChange={e => setEmail(e.target.value)}
                                style={{color: Color.thirdText}}
                                onKeyPress={handleKeyPress}
                                required
                                />
                        </div>
                        <div className='login-label-input-container'>
                            <label htmlFor='password' className='login-label'>
                                Password
                            </label>
                            <input
                                type={showPassword ? 'text' : 'password'}
                                id='password'
                                className='login-input'
                                placeholder='password'
                                value={password}
                                onChange={e => setPassword(e.target.value)}
                                style={{color: Color.thirdText}}
                                onKeyPress={handleKeyPress}
                                required
                                />
                            <span className={`login-eye-password ${showPassword ? 'fa-solid fa-eye' : 'fa-solid fa-eye-slash'}`} onClick={() => setShowPassword(eye => !eye)} style={{color: Color.thirdText}}></span>
                        </div>
                        <div className='login-form-forgot-container'>
                                <button className='login-form-forgot-btn' onClick={handleForgotPasswordPage}>
                                    Forgot Password?
                                </button>
                            </div>
                        <div className='login-btn-container'>
                            <button className='login-btn'>Login</button>
                        </div>
                    </form>

                    <div className='login-register-btn-container'>
                        <div className='login-register-container'>
                            Don't have an account? <span className='login-register-span'>Register</span> 
                        </div>
                    </div>

                </div>
                <div className={`loading-container-overlay ${loading ? "" : "stop"}`}>
                    <ClipLoader size={100} color='white' />
                </div>
            </div>
            <CustomSnackbar
                severity={severitySnackbar}
                message={messageSnackbar}
                open={openSnackbar}
                onClose={() => setOpenSnackbar(false)}
                time= {snackbarDuration}
            />
        </>
    )
}

export default LoginPage;